let requestCount = 0
export function getRequestSuccessOrFail() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      requestCount++ % 2 == 0
        ? setTimeout(() => {
            resolve({
              response: {
                status: 200
              }
            })
          }, 500)
        : setTimeout(() => {
            reject({
              response: {
                status: 500
              }
            })
          }, 500)
    }, 500)
  })
}
